import get from 'lodash/fp/get';
import flow from 'lodash/fp/flow';
import isEmpty from 'lodash/fp/isEmpty';
import negate from 'lodash/fp/negate';

export const getTotalServiceRevenue = get('analytics.totalServiceRevenue');
export const getTotalRevenue = get('analytics.totalRevenue');
export const getTotalRevenueWithTax = get('analytics.totalRevenueWithTax');
export const getNetServiceRevenue = get('analytics.netServiceRevenue');
export const getServiceCount = get('analytics.serviceCount');
export const getTotalProductRevenue = get('analytics.totalProductRevenue');
export const getNetProductRevenue = get('analytics.netProductRevenue');
export const getProductCount = get('analytics.productCount');
export const getNewCustomers = get('analytics.newCustomers');
export const getIsFetching = flow([
  get('analytics.isFetching'),
  negate(isEmpty),
]);
